import React from 'react';
import { motion } from 'framer-motion';
export function DifferentiatorSection() {
  return <section className="py-14 md:py-24 px-5 md:px-6 bg-[#0d1221]" data-id="element-31">
      <div className="max-w-3xl mx-auto text-center" data-id="element-32">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-2xl md:text-4xl font-playfair text-[#f5f0e8] mb-8 md:mb-12" data-id="element-33">
          What makes this different
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="space-y-6 md:space-y-8" data-id="element-34">
          <p className="text-lg md:text-xl text-[#8b8178]" data-id="element-35">
            This isn't "how to sleep better."
          </p>

          <p className="text-xl md:text-3xl font-light text-[#e8e0d4]" data-id="element-36">
            It's:
            <br data-id="element-37" />
            <strong className="text-[#c9a96e] font-playfair block mt-3 md:mt-4 text-2xl md:text-4xl" data-id="element-38">
              what to do when you're awake and your brain is about to ruin the
              rest of the night.
            </strong>
          </p>

          <div className="py-6 md:py-12 space-y-3 md:space-y-4" data-id="element-39">
            <p className="text-base md:text-lg text-[#8b8178] mb-4 md:mb-6" data-id="element-40">
              Because the real win is not "never waking up." The real win is:
            </p>

            <div className="inline-block text-left space-y-3 md:space-y-4 bg-[#111827] p-5 md:p-8 rounded-xl border border-[#ffffff]/5 shadow-xl" data-id="element-41">
              {['you wake up', "you don't panic", "you don't problem-solve", "you don't train your brain to fear the bed"].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.15,
              duration: 0.8
            }} className="flex items-center text-base md:text-xl text-[#e8e0d4]" data-id="element-42">
                  <span className="w-2 h-2 rounded-full bg-[#c9a96e] mr-3 md:mr-4 flex-shrink-0" data-id="element-43" />
                  {item}
                </motion.div>)}
            </div>
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 1.5
        }} className="text-xl md:text-3xl font-playfair italic text-[#c9a96e]" data-id="element-44">
            …and you drift back more often than you expect.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}